import { useMutation } from '@tanstack/react-query';
import type { CandidateEndpointBulkResetPostRequest } from '../types/CandidateProfile';

export default function usePostCandidateEndpointBulkReset() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({ candidateProfileId, ids }: CandidateEndpointBulkResetPostRequest) => {
      const response = await fetch(
        `/agent/api/candidate_endpoints/${candidateProfileId}/bulk_reset`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-CSRF-Token': token,
          },
          body: JSON.stringify({ ids }),
        }
      );
      const data = await response.json();
      return data;
    },
  });
}
